import React from 'react'
import styled from 'styled-components'

import { MOBILE_BREAKPOINT } from 'broker/util/constants'

const Row = ({ className, children }) => (
  <div className={className}>
    {children}
  </div>
)

export default styled(Row)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  height: fit-content;
  margin: 0;
  justify-content: space-between;
  
  @media${MOBILE_BREAKPOINT} {
    flex-direction: column;
  }
`
